import { useState } from 'react';

// Interfaces
interface ThumbnailMakerState {
  showEditor: boolean;
  showToolbar: boolean;
  showPanel: boolean;
}

interface UseThumbnailMakerReturn {
  state: ThumbnailMakerState;
  toggleEditor: () => void;
  toggleToolbar: () => void;
  togglePanel: () => void;
}

/**
 * Hook for Thumbnail Maker functionality
 */
export function useThumbnailMaker(): UseThumbnailMakerReturn {
  const [state, setState] = useState<ThumbnailMakerState>({
    showEditor: true,
    showToolbar: true,
    showPanel: true
  });

  /**
   * Toggle editor visibility
   */
  const toggleEditor = (): void => {
    setState(prev => ({
      ...prev,
      showEditor: !prev.showEditor
    }));
  };

  /**
   * Toggle toolbar visibility
   */
  const toggleToolbar = (): void => {
    setState(prev => ({
      ...prev,
      showToolbar: !prev.showToolbar
    }));
  };

  /**
   * Toggle panel visibility
   */
  const togglePanel = (): void => {
    setState(prev => ({
      ...prev,
      showPanel: !prev.showPanel
    }));
  };

  return {
    state,
    toggleEditor,
    toggleToolbar,
    togglePanel
  };
} 